import React from "react";
import { ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { useRoute } from "@react-navigation/native";

import Container from "../../components/Container";
import Header from "../../components/Header";
import Text from "../../components/Text";
import { colors, fonts } from "../../theme";

const SERVICE_TYPE_ICON: Record<string, string> = {
  piercing: "◆",
  tattoo: "✎",
  permanent_makeup: "✦",
};

const styles = StyleSheet.create({
  container: { backgroundColor: colors.black, flex: 1 },
  scrollView: { paddingHorizontal: 20 },
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginTop: 10,
  },
  card: {
    width: "48.5%",
    backgroundColor: "#262b42",
    borderWidth: 1.5,
    borderColor: "#2a2d3f",
    borderRadius: 14,
    padding: 14,
    marginBottom: 12,
  },
  icon: {
    width: 40,
    height: 40,
    borderRadius: 12,
    backgroundColor: colors.darkestGrey,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 10,
  },
  iconText: { fontSize: 18, color: colors.white },
  name: { fontFamily: fonts.semiBold, color: colors.white, fontSize: 14 },
});

type Props = { navigation: any };

const ServiceTypeSelectionScreen: React.FC<Props> = ({ navigation }) => {
  const { params } = useRoute<any>();
  const store = params?.store;
  const serviceTypes = store?.serviceTypes || [];

  return (
    <SafeAreaView style={styles.container} edges={["right", "bottom", "left"]}>
      <Container>
        <ScrollView style={styles.scrollView}>
          <Header
            title="What are you here for?"
            description="Choose a category to see available services."
          />

          <View style={styles.grid}>
            {serviceTypes.map((serviceType: any) => (
              <TouchableOpacity
                key={serviceType.id}
                style={styles.card}
                onPress={() =>
                  navigation.navigate("ServiceCategorySelection", { store, serviceType })
                }
              >
                <View style={styles.icon}>
                  <Text style={styles.iconText}>
                    {SERVICE_TYPE_ICON[serviceType.type] || "•"}
                  </Text>
                </View>
                <Text style={styles.name}>{serviceType.name}</Text>
              </TouchableOpacity>
            ))}
          </View>
        </ScrollView>
      </Container>
    </SafeAreaView>
  );
};

export default ServiceTypeSelectionScreen;
